/**
 * account_pricing.js
 * 处理包月/包年切换和 FAQ 手风琴效果
 */
(function () {
    'use strict';

    // ── 包月/包年切换 ──────────────────────────────────────────────────────
    var isAnnual = true; // 默认年付（与 HTML 初始状态一致）

    var toggle = document.getElementById('billing-toggle');
    var thumb  = toggle ? toggle.querySelector('.toggle-thumb') : null;

    function updateToggleUI() {
        if (!toggle || !thumb) return;

        if (isAnnual) {
            toggle.classList.add('annual');
            toggle.classList.remove('monthly');
            thumb.classList.add('annual');
            thumb.classList.remove('monthly');
            document.body.classList.remove('billing-monthly');
        } else {
            toggle.classList.add('monthly');
            toggle.classList.remove('annual');
            thumb.classList.add('monthly');
            thumb.classList.remove('annual');
            document.body.classList.add('billing-monthly');
        }

        // 更新标签高亮
        var labels = document.querySelectorAll('.toggle-label');
        if (labels.length >= 2) {
            labels[0].classList.toggle('active', !isAnnual); // Monthly
            labels[1].classList.toggle('active', isAnnual);  // Annual
        }
    }

    if (toggle) {
        toggle.addEventListener('click', function () {
            isAnnual = !isAnnual;
            updateToggleUI();
        });
    }

    // 初始化状态
    updateToggleUI();

    // ── FAQ：点开一个自动关闭其他 ─────────────────────────────────────────
    var faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(function (item) {
        item.addEventListener('toggle', function () {
            if (item.open) {
                faqItems.forEach(function (other) {
                    if (other !== item) other.removeAttribute('open');
                });
            }
        });
    });

})();
